import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../../../utils/form";
import i18n from "../../../../../../../i18n";
import { Button, Divider, Form } from "ant-design-vue";
import {
    /*createFieldAttachment,*/
    createFieldImage,
    createFieldTemplateBuilder,
} from "../../../../../../../components/input/template-builder/template-builder.logic";
// import { useForm as createUseForm } from "@ant-design-vue/use";
import { createLoading } from "../../../../../../../utils/loading";
import { defineAsyncComponent } from "vue";
import { addModal, removeModal } from "../../../../../../../app.logic";
import { modalStyleForm } from "../../../../../../../utils/constant";
import { parseUrl } from "../../../../../../../utils/util";

export const { isLoading, setIsLoading } = createLoading();
export const CIcon = defineAsyncComponent(() => import("../../../../../../../components/icon/CIcon"));

export const createField = ({ props, data }) => {
    const key = props.dataKey;
    const { viewOnly, labelExampleImage, attachmentGroup, canCreate, previewPicture, isShowOriginalVesselAttachment, hiddenPreviewButton } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}exampleAttachment.0`,
                colProp: () => ({ xs: 24, md: isShowOriginalVesselAttachment ? 4 : 10, style: { margin: "auto" } }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 }, align: "center" }),
                label: () => i18n.global.t(labelExampleImage),
                formItemRender: ({ field }) => {
                    const label = field?.label?.();
                    const formItemProp = field?.formItemProp?.({ field });
                    const buttonPreview = (
                        <Button
                            size="medium"
                            onClick={() => {
                                openModalExampleImage({ file: previewPicture });
                            }}
                        >
                            <CIcon file="eye.svg"></CIcon>
                            <span>{i18n.global.t("views.request.licenseRequest.exampleImage")}</span>
                        </Button>
                    );
                    return hiddenPreviewButton ? (
                        <Form.Item label={label} {...formItemProp}></Form.Item>
                    ) : (
                        <Form.Item label={label} {...formItemProp}>
                            {buttonPreview}
                        </Form.Item>
                    );
                },
            },
            {
                key: `${prefix}dividerAttachment.0`,
                visible: ({ field }) =>
                    conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && !isShowOriginalVesselAttachment,
                colProp: () => ({ xs: 24, md: 2, align: "center" }),
                formItemRender: () => <Divider dashed={true} orientation={"center"} type={"vertical"} style={{ height: "100%" }}></Divider>,
            },
            createFieldTemplateBuilder({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, md: isShowOriginalVesselAttachment ? 10 : 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        {
                            visible: () => isShowOriginalVesselAttachment,
                            colProp: () => ({ xs: 24, md: 24 }),
                            formItemRender: () => <div class="text-center">ภาพเรือปัจจุบัน</div>,
                        },
                        {
                            visible: () => !isShowOriginalVesselAttachment,
                            colProp: () => ({ xs: 24, md: 24 }),
                            formItemRender: () => <div class="text-center">ภาพเรือเดิม</div>,
                        },
                        createFieldImage({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}size`,
                            colProp: () => ({ xs: 24, md: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 }, align: "center", validateStatus: null, help: null }),
                            label: () => "",
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model?.url || model?.blob ? model : null,
                                        "onUpdate:value": (value) => {
                                            const refAttach = model;
                                            if(value) {
                                                refAttach.documentName = refAttach?.documentName ? refAttach?.documentName : value.name;
                                                refAttach.name = value.name;
                                                refAttach.group = value.group;
                                                refAttach.blob = value.blob;
                                                refAttach.type = value.type;
                                                refAttach.size = value.size;
                                            } else {
                                                refAttach.name = null;
                                                refAttach.blob = null;
                                                refAttach.type = null;
                                                refAttach.size = null;
                                            }
                                            refAttach.url = null;
                                            refAttach.path = null;
                                            refAttach.isSave = true;
                                            modelRef.refVesselRequest.isSave = true;
                                        },
                                        group: attachmentGroup,
                                        disabled: viewOnly ? true : !canCreate,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        // createFieldAttachment({
                        //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                        //     key: `${prefix}size`,
                        //     colProp: () => ({ xs: 24, md: 24 }),
                        //     formItemProp: () => ({ labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 }, align: 'center' }),
                        //     label: () => "",
                        //     inputProp: ({ field }) => {
                        //         return lodash.merge(
                        //             {
                        //                 value: model?.url || model?.blob ? model : null,
                        //                 "onUpdate:value": value => {
                        //                     const refAttach = model;
                        //                      if(value) {
                        //                          refAttach.documentName = refAttach?.documentName ? refAttach?.documentName : value.name;
                        //                          refAttach.name = value.name;
                        //                          refAttach.group = value.group;
                        //                          refAttach.blob = value.blob;
                        //                          refAttach.type = value.type;
                        //                          refAttach.size = value.size;
                        //                      } else {
                        //                          refAttach.name = null;
                        //                          refAttach.blob = null;
                        //                          refAttach.type = null;
                        //                          refAttach.size = null;
                        //                      }
                        //                      refAttach.url = null;
                        //                      refAttach.path = null;
                        //                      refAttach.isSave = true;
                        //                      modelRef.refVesselRequest.isSave = true;
                        //                 },
                        //                 group: attachmentGroup,
                        //                 disabled: viewOnly ? true : !canCreate
                        //             },
                        //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                        //         );
                        //     }
                        // }),
                    ]}),
                }),
            }),
        ],
    });
};

export const initForm = ({ props, data, refs }) => {
    // data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
};

export const openModalExampleImage = ({ file }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            width: "600px",
            onCancel: () => {
                removeModal({ options });
            },
            onOk: () => {
                options.bind.onCancel();
            },
        }),
        render: () => {
            // const img = <img className="w-100" src={`data:image/jpeg;base64,${file.blob}`} alt={file.name}/>
            const img = <img class="w-100" src={parseUrl(file?.url)} alt={file?.name} />;
            return <div>{img}</div>;
        },
        /*
        * render: () => {
            const img = !file?.type?.includes?.("image/") ? <div>Cannot Preview</div>
                : file?.blob && file?.type && file?.name ? <img className="w-100" src={`data:${file.type};base64,${file.blob}`} alt={file.name}/>
                : file?.url ? <img class="w-100" src={file.url} alt={file.name} />
                : <div>Cannot Preview</div>;
            return <div>{img}</div>
        }*/
    });
    return options;
};
